import mitt from 'mitt'

import {
    computed,
    reactive
} from "vue";

const VueEvent = mitt();

/**
 * 控件互通 (但不跨瀏覽器的頁籤)
 */
export const useMitt = () => {

    /**
     * 參數 - 本地
     */
    const active = reactive({
        loadingMask: false,
        offCanvas: false,
        reloadPage: false,
        dialog: false,
        preview: true,
        lightbox: {
            index: 0,
            show: false,
            download: false,
            images: []
        },
        visible: {
            change: {
                select: false
            }
        }
    })

    /**
     * 將body捲軸鎖起來
     */
    const lockBody = (e) => {
        const body = document.getElementsByTagName("BODY")[0];
        e ? body.classList.add("dropdown-lockout") : body.classList.remove("dropdown-lockout")
    }

    /**
     * 回傳讀取遮罩
     */
    const isLoadingMask = computed(() => active.loadingMask)

    /**
     * 設定讀取遮罩
     */
    const setLoadingMask = (enable) => VueEvent.emit("loadingMask", enable)

    /**
     * 回傳右滑選單
     */
    const isOffCanvas = computed(() => active.loadingMask)

    /**
     * 設定右滑選單
     */
    const setOffCanvas = (enable) => {
        lockBody(enable)
        VueEvent.emit("offCanvas", enable)
    }

    /**
     * 回傳重刷頁面
     */
    const isReloadPage = computed(() => active.reloadPage)

    /**
     * 設定重刷頁面
     */
    const setReloadPage = (enable) => {
        VueEvent.emit("reloadPage", enable)
    }

    /**
     * 回傳文章是否產生可以預覽
     */
    const isPreview = computed(() => {
        return active.preview
    })

    /**
     * 設定文章是否產生可以預覽
     */
    const setPreview = (enable) => {
        VueEvent.emit("preview", enable)
    }

    /**
     * 回傳dialog
     */
    const isDialog = computed(() => {
        return active.dialog
    })

    /**
     * 設定dialog
     */
    const setDialog = (enable) => {
        lockBody(enable)
        VueEvent.emit("dialog", enable)
    }

    /**
     * 回傳幻燈箱參數
     */
    const getLightBox = computed(() => {
        return active.lightbox
    })

    /**
     * 設定幻燈箱參數
     */
    const setLightBox = (
        show = false,
        images,
        index,
        download
    ) => {
        if ( show ) VueEvent.emit("lightBox", {
            show: true,
            images: images,
            index: index,
            download: download
        })
        //如果是關閉的話, 順便關閉下載
        else VueEvent.emit("lightBox", {
            show: false,
            images: [],
            index: 0,
            download: false
        })
    }

    /**
     * 設定element下拉選單
     */
    const setVisibleChangeSelect = (e) => {
        VueEvent.emit("selectVisibleChange", e)
    }

    /**
     * 回傳element下拉選單
     */
    const isVisibleChangeSelect = computed(() => {
        return active.visible.change.select
    })

    /**
     * 監控遮罩變化
     */
    VueEvent.on("loadingMask", (enable)=>{
        if (typeof enable === "boolean") active.loadingMask = enable
    })

    /**
     * 監控右滑選單
     */
    VueEvent.on("offCanvas", (enable)=>{
        if (typeof enable === "boolean") active.offCanvas = enable
    })

    /**
     * 監控重刷頁面
     */
    VueEvent.on("reloadPage", (enable)=>{
        if (typeof enable === "boolean") active.reloadPage = enable
    })

    /**
     * 監控dialog
     */
    VueEvent.on("dialog", (enable)=>{
        if (typeof enable === "boolean") active.dialog = enable
    })

    /**
     * 文章是否產生可以預覽
     */
    VueEvent.on("preview", (enable)=>{
        if (typeof enable === "boolean") active.preview = enable
    })

    /**
     * 下拉選單變化
     */
    VueEvent.on("selectVisibleChange", (e)=>{
        if (typeof e === "boolean") active.visible.change.select = e
    })

    /**
     * 監控幻燈箱參數
     */
    VueEvent.on("lightBox", (data)=>{
        const r = data;
        active.lightbox.show = r.show
        active.lightbox.images = r.images
        active.lightbox.index = r.index
        active.lightbox.download = r.download
    })

    return {
        isLoadingMask,
        setLoadingMask,
        isOffCanvas,
        setOffCanvas,
        isReloadPage,
        setReloadPage,
        isDialog,
        setDialog,
        isPreview,
        setPreview,
        getLightBox,
        setLightBox,
        isVisibleChangeSelect,
        setVisibleChangeSelect,
    }

}
